import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Paginate from "src/shared/Paginate";
import MovieList from "src/shared/MovieList/MovieList";

import { MoviesData } from "src/types/movieData";
import Loader from "src/shared/Loader";
import { getMoviesList } from "src/shared/api";

const NowPlaying = () => {
  const [data, setData] = useState<MoviesData | null>(null);

  let { currentPage } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getMoviesList("now_playing", currentPage as string).then((response) =>
      setData(response.data),
    );
  }, [currentPage]);

  const onChangePage = (selectedNumber: { selected: number }) => {
    navigate(`/nowplaying/${selectedNumber.selected + 1}`);
  };

  if (!data) {
    return <Loader />;
  }

  return (
    <div>
      <MovieList movies={data.results} />

      <Paginate onPageChange={onChangePage} pageCount={data.total_pages} />
    </div>
  );
};

export default NowPlaying;
